import InfiniteScroll from 'infinite-scroll'

const el = document.querySelector('.pt-advice__more')
if (el) {
  const button = document.querySelector('.pt-advice__more')
  let append = true

  const loadMore = new InfiniteScroll(
    document.querySelector('.pt-advice__list'),
    {
      path: 'a.next.page-numbers',
      append: '.feed-advice',
      history: 'push',
      button: '.pt-advice__more',
      scrollThreshold: false,
      hideNav: '.pt-advice__nav',
      status: '.pt-advice__status',
    }
  )

  loadMore.on('request', () => {
    button.style.display = 'none'
  })

  loadMore.on('append', () => {
    if (append) {
      button.style.display = ''
    }
  })

  loadMore.on('last', () => {
    append = false
    button.style.display = 'none'
  })
}
